import React, { useEffect, useState } from 'react'
import { Error, LoadingSpinner } from '../../components'
import getAuth0 from '../../utils/auth0'
import feature from '../../utils/feature'
import { newRelicTriggerErrorEvent } from '../../utils/newrelic'

export default function BrowseLogout(): JSX.Element {
  const [error, setError] = useState<{ code: string } | null>(null)
  const accountLogoutEnabled = feature.enabled('ACCOUNT_LOGOUT')
  const browseUrl = `${window.location.origin}/#homepage`
  const signOutUrl = `${window.auth.ACCOUNT_URL}/sign-out?continueUrl=${encodeURIComponent(
    browseUrl,
  )}`
  const returnTo = accountLogoutEnabled ? browseUrl : signOutUrl

  useEffect(() => {
    ;(async () => {
      try {
        const auth0 = getAuth0()
        await auth0.atg.signOut()
        if (accountLogoutEnabled) await auth0.account.logout()
        await auth0.logout({ returnTo })
      } catch (error) {
        console.error(error)
        newRelicTriggerErrorEvent('browse-logout', error)
        setError({ code: 'browse.logout.error' })
      }
    })()
  }, [])

  return <div data-test="browse-logout">{error ? <Error /> : <LoadingSpinner />}</div>
}
